import { Select, Space, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
const { Text } = Typography;

interface NewSelectProps {
  handleChange: (value: string | string[] | null) => void;
  options: { value: string; label: string }[];
  value: string | string[] | null;
  selectStyle?: React.CSSProperties;
  selectClassName?: string;
  label?: string;
  isSearchable?: boolean;
  loading?: boolean;
  placeholder?: string;
  isMultiple?: boolean;
  clearable?: boolean;
}

export default function NewSelect({
  handleChange,
  options,
  value,
  selectStyle,
  selectClassName = '',
  label,
  isSearchable = false,
  loading = false,
  placeholder = 'Select',
  isMultiple = false,
  clearable = false,
}: NewSelectProps) {
  return (
    <Space
      direction="vertical"
      size={6}
      className="new-select-container"
      style={{ width: '100%' }}
    >
      {label && <Text className="new-select-label">{label}</Text>}
      <Select
        value={value}
        style={{ width: '100%', ...selectStyle }}
        onChange={handleChange}
        options={options}
        className={`new-select ${selectClassName}`}
        showSearch={isSearchable}
        optionFilterProp="label"
        loading={loading}
        placeholder={placeholder}
        mode={isMultiple ? 'multiple' : undefined}
        suffixIcon={<DownOutlined />}
      />
    </Space>
  );
}
